SA.fixScrollbars = function(el) {
    var dom = Ext.getDom(el);

    if (dom.scrollHeight - dom.offsetHeight < 4 && dom.scrollWidth - dom.offsetWidth < 4) {
        Ext.fly(dom).addCls('sa-no-scroll');

        SA.fixScrollbars.dummy = dom.scrollHeight;

        Ext.fly(dom).removeCls('sa-no-scroll');
    }
};